import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import EirOfferCardHeader from './EirOfferCardHeader';
import EirOfferCardBody from './EirOfferCardBody';
import EirOfferCardFooter from './EirOfferCardFooter';
import StyledCard from './Card.styled';
import styles from './styles';

const EirOfferCard = ({
  headerImgDescription,
  topTag,
  offer,
  preTitle,
  title,
  headerImage = [],
  headerImageActive = [''],
  sash,
  contractLength,
  priceIncreaseTagline = [''],
  afterPrice,
  afterPricePosition,
  price,
  noDiscount,
  description,
  descriptions,
  discountDuration,
  openDialog,
  selectButton,
  promotion,
  moreInfo,
  index,
  offerSelected,
  styleCard,
  loading,
  code,
  showLoader,
  color,
  switchTheme = false,
  useMaxHeight,
  showCounter = false,
  offerCount,
  allowedToAdd = false,
  isMobile = false,
  isTv = false,
  isBroadband = false,
  isMbb = false,
  isPrepayMobile,
  isAddon,
  onOfferSelect,
  onOfferUnSelect,
  handsetPrice,
  offerCardButtonDisable,
  tvMobileViewImg,
  slideNumber,
  cmsData, // cmsData here is main page cmsData's attributes object
}) => {
  const theme = useTheme();
  const [style, setStyle] = useState(styles(theme, color));
  const [cardHovered, setCardHovered] = useState(false);
  const [headerImgLoaded, setHeaderImgLoaded] = useState('');
  const lg = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    const updatedStyle = { ...styles(theme, color), ...styleCard };
    setStyle(updatedStyle);
  }, [styleCard, color]);

  const cardBody = useRef(null);
  useEffect(() => {
    if (cardBody && useMaxHeight) {
      useMaxHeight?.set(cardBody.current.clientHeight);
      // if (!selectButton) useMaxHeight?.set(cardBody.current.clientHeight, true);
      // else useMaxHeight?.set(cardBody.current.clientHeight);
    }
  }, [cardBody, useMaxHeight?.value, selectButton, headerImgLoaded]);

  return (
    <Stack
      sx={style.offerCard}
      className='offer-card'
      onMouseEnter={() => {
        setCardHovered(true);
      }}
      onMouseLeave={() => {
        setCardHovered(false);
      }}
    >
      {/* top tag */}
      <Box sx={topTag?.length > 0 ? style.topTag : [style.topTag, { bgcolor: 'transparent' }]}>
        <Typography
          dangerouslySetInnerHTML={{ __html: topTag }}
          sx={{
            fontFamily: theme.typography.h1.fontFamily,
            lineHeight: '2.0',
            color: theme.palette.secondary.contrastText,
          }}
          // className='swiper-no-swiping'
        />
      </Box>

      {/* card */}
      <Box sx={style.container} id={code}>
        {/* <Stack sx={{ height: '100%' }}> */}
        <StyledCard
          className='offer-card-body'
          ref={cardBody}
          color={color}
          sx={{
            ...(loading && {
              border: 0,
              padding: '0.3rem',
              width: '22.5rem',
              background: theme.palette.primary.SkeletonBackground,
            }),
            ...(offerSelected === false &&
              (switchTheme === false
                ? { borderColor: theme?.palette.primary.offerMain }
                : { borderColor: theme?.palette.primary.OfferSelected })),
            ...(offerSelected === true &&
              (switchTheme === false
                ? { borderColor: theme?.palette.primary.OfferSelected }
                : { borderColor: theme?.palette.primary.offerMain })),
            ...(moreInfo?.length === 0 || isAddon || isPrepayMobile
              ? { borderRadius: '20px' }
              : {}),
            ...(useMaxHeight?.value ? { minHeight: useMaxHeight?.value } : ''),
            ...(isTv && { border: 0 }),
            ...(!isTv && offerSelected === true
              ? { ...styles(theme, color)?.singleStyledCardSelected }
              : {}),
            ...(isBroadband &&
              offerSelected === true && {
                border: `3px solid ${theme?.palette.primary.OfferSelected}`,
              }),
            ...(isMobile && offerSelected === true && switchTheme === true
              ? { borderColor: theme?.palette.primary.simoSelected }
              : ''),
            ...{ display: 'flex', flexDirection: 'column' },
            ...(lg && { width: '22.5rem' }),
          }}
        >
          {/* header */}
          <EirOfferCardHeader
            {...{ preTitle, title, sash, headerImage, headerImgDescription }}
            slideNumber={slideNumber}
            loading={loading}
            offerSelected={offerSelected}
            style={style.head}
            color={color}
            switchTheme={switchTheme}
            isMobile={isMobile}
            isTv={isTv}
            headerImageActive={headerImageActive}
            cardHovered={cardHovered}
            isBroadband={isBroadband}
            isMbb={isMbb}
            tvMobileViewImg={tvMobileViewImg}
            setHeaderImgLoaded={setHeaderImgLoaded}
            isAddon={isAddon}
          />
          {/* body */}
          <EirOfferCardBody
            {...{
              title,
              price,
              afterPrice,
              afterPricePosition,
              noDiscount,
              contractLength,
              description,
              priceIncreaseTagline,
              descriptions,
              discountDuration,
              selectButton,
              promotion,
              index,
              style,
              offerSelected,
              offer,
              showCounter,
              offerCount,
              code,
              showLoader,
              preTitle,
            }}
            slideNumber={slideNumber}
            openDialog={openDialog}
            loading={loading}
            style={style.body}
            color={color}
            switchTheme={switchTheme}
            allowedToAdd={allowedToAdd}
            onOfferSelect={onOfferSelect}
            onOfferUnSelect={onOfferUnSelect}
            isTv={isTv}
            isAddon={isAddon}
            isMobile={isMobile}
            isPrepayMobile={isPrepayMobile}
            isBroadband={isBroadband}
            offerCardButtonDisable={offerCardButtonDisable}
            isMbb={isMbb}
            handsetPrice={handsetPrice}
            cmsData={cmsData}
          />
          {/* {handsetPrice?.length > 0 && handsetPrice >= 0 && (
            <Typography variant='body1' sx={{ ...styles(theme).brandPriceText, marginTop: 'auto' }}>
              Phone cost:&nbsp;
              {handsetPrice[0] === 0 ? (
                <Typography variant='h5' sx={styles(theme).brandPrice}>
                  Free
                </Typography>
              ) : (
                <Typography variant='h5' sx={styles(theme).brandPrice}>
                  {`€${(handsetPrice / 100).toFixed()}`}
                </Typography>
              )}
            </Typography>
          )} */}
          {/* {priceIncreaseTagline?.length > 0 && !isBroadband && !isMbb && (
            <Typography
              component='p'
              sx={{
                ...style?.priceIncreaseTagline,
                marginTop: handsetPrice?.length > 0 ? '0' : 'auto',
              }}
              className='swiper-no-swiping'
            >
              <span dangerouslySetInnerHTML={{ __html: priceIncreaseTagline[0] }} />
              {priceIncreaseTagline}
            </Typography>
          )} */}
        </StyledCard>
        {/* </Stack> */}
      </Box>

      {/* footer */}
      <EirOfferCardFooter
        title={title}
        moreInfo={moreInfo}
        style={style.footer}
        loading={loading}
        offerSelected={offerSelected}
        afterPricePosition={afterPricePosition}
        color={color}
        switchTheme={switchTheme}
        slideNumber={slideNumber}
        isTv={isTv}
        preTitle={preTitle}
      />
    </Stack>
  );
};

export default EirOfferCard;
